import React, { ChangeEventHandler, memo, type FC } from "react";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { t } from "i18next";
import SuplementationList from "./ListSuplementation";
import { Meal } from "@/app/nutrition/meal.enum";
import { Option } from "@/app/nutrition/option.enum";

export type SearchSuplementationProps = {
  isLoading?: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  search: string;
  data: Array<any>;
  onSetSuplementation: (
    suplementation: any,
    meal: Meal,
    option: Option
  ) => void;
};

export const SearchSuplementation: FC<SearchSuplementationProps> = memo(
  ({ isLoading, onChange, search, data, onSetSuplementation }) => {
    return (
      <div className="flex flex-col flex-grow">
        <div className="flex flex-col flex-shrink-0">
          <div className="p-4 pb-0 border-gray-300">
            <InputWithCornerHint
              label={t("general.search")}
              placeholder={t("nutrition-wizard.views.suplementation")}
              type="text"
              name="suplementation"
              onChange={onChange}
              value={search}
            />
          </div>
          <div className="col-span-full">
            <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 text-center pb-3 mt-4">
              {t("nutrition-wizard.views.supplementation")}
            </h1>
          </div>
        </div>
        <SuplementationList
          isLoading={isLoading}
          data={data}
          onSetSuplementation={onSetSuplementation}
        />
      </div>
    );
  }
);
